import React from "react";

const PortionAmount = ({
  setAmount,
  coinBalance,
  coinRate,
  onPortionSelect,
}: any) => {
  const handleSetAmount = (portion?: number) => {
    if (!coinBalance || portion == null) {
      setAmount("");
      onPortionSelect?.(0, 0, 0);
      return;
    }

    const rawCrypto = coinBalance * portion;

    // If coinRate exists → convert to USD
    const rawUsd = coinRate ? rawCrypto * coinRate : null;

    // Set the raw number value (not formatted) so it can be used in calculations
    const rawValue = rawUsd !== null ? Number(rawUsd) : Number(rawCrypto);
    setAmount(rawValue);

    // Pass 3 values, USD may be null
    onPortionSelect?.(portion, rawCrypto, rawUsd);
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => handleSetAmount(0.25)}
        className="text-gray-500 dark:text-gray-300 text-[11px] font-medium bg-gray-100 dark:bg-gray-700 rounded-lg p-2"
      >
        25%
      </button>
      <button
        onClick={() => handleSetAmount(0.5)}
        className="text-gray-500 dark:text-gray-300 text-[11px] font-medium bg-gray-100 dark:bg-gray-700 rounded-lg p-2"
      >
        50%
      </button>
      <button
        onClick={() => handleSetAmount(0.75)}
        className="text-gray-500 dark:text-gray-300 text-[11px] font-medium bg-gray-100 dark:bg-gray-700 rounded-lg p-2"
      >
        75%
      </button>
      <button
        onClick={() => handleSetAmount(0.998)}
        className="text-secondary_button text-[11px] font-semibold rounded-lg bg-gray-100 dark:bg-gray-700 p-2"
      >
        MAX
      </button>
    </div>
  );
};

export default PortionAmount;
